import {defineMessages} from 'react-intl'

export const caProvinceMessages = defineMessages({
    'state.ca.alberta': {
        id: 'state.ca.alberta',
        defaultMessage: 'Alberta'
    },
    'state.ca.british_columbia': {
        id: 'state.ca.british_columbia',
        defaultMessage: 'British Columbia'
    },
    'state.ca.manitoba': {
        id: 'state.ca.manitoba',
        defaultMessage: 'Manitoba'
    },
    'state.ca.new_brunswick': {
        id: 'state.ca.new_brunswick',
        defaultMessage: 'New Brunswick'
    },
    'state.ca.newfoundland_and_labrador': {
        id: 'state.ca.newfoundland_and_labrador',
        defaultMessage: 'Newfoundland and Labrador'
    },
    'state.ca.nova_scotia': {
        id: 'state.ca.nova_scotia',
        defaultMessage: 'Nova Scotia'
    },
    'state.ca.ontario': {
        id: 'state.ca.ontario',
        defaultMessage: 'Ontario'
    },
    'state.ca.prince_edward_island': {
        id: 'state.ca.prince_edward_island',
        defaultMessage: 'Prince Edward Island'
    },
    'state.ca.quebec': {
        id: 'state.ca.quebec',
        defaultMessage: 'Quebec'
    },
    'state.ca.saskatchewan': {
        id: 'state.ca.saskatchewan',
        defaultMessage: 'Saskatchewan'
    },
    'state.ca.northwest_territories': {
        id: 'state.ca.northwest_territories',
        defaultMessage: 'Northwest Territories'
    },
    'state.ca.nunavut': {
        id: 'state.ca.nunavut',
        defaultMessage: 'Nunavut'
    },
    'state.ca.yukon': {
        id: 'state.ca.yukon',
        defaultMessage: 'Yukon'
    }
})

export const caProvinceOptions = [
    {value: 'AB', label: 'state.ca.alberta'},
    {value: 'BC', label: 'state.ca.british_columbia'},
    {value: 'MB', label: 'state.ca.manitoba'},
    {value: 'NB', label: 'state.ca.new_brunswick'},
    {value: 'NL', label: 'state.ca.newfoundland_and_labrador'},
    {value: 'NS', label: 'state.ca.nova_scotia'},
    {value: 'ON', label: 'state.ca.ontario'},
    {value: 'PE', label: 'state.ca.prince_edward_island'},
    {value: 'QC', label: 'state.ca.quebec'},
    {value: 'SK', label: 'state.ca.saskatchewan'},
    {value: 'NT', label: 'state.ca.northwest_territories'},
    {value: 'NU', label: 'state.ca.nunavut'},
    {value: 'YT', label: 'state.ca.yukon'}
]
